import { BreachEvent } from '@news-mono/web-common'
import React from 'react'
import { MessageBanner } from '../../../../../banners/MessageBanner/MessageBanner'
import BlackFridayBreachContent from './BlackFridayBreachContent'
import { StyledWestRewardsMessage } from './BlackFridayComponents/BlackFridayWestRewardsMessage.styled'
import { breachPackages } from '../../../common'
export interface BreachNotificationProps {
    breachCreativeName: string
    breachDeal: string
    breachType: string
    onEvent: (event: BreachEvent) => void
}

export function BlackFridayBreachNotification({
    breachDeal,
    breachCreativeName,
    breachType,
    onEvent,
}: BreachNotificationProps) {
    return (
        <div data-testid="BreachScreen">
            <MessageBanner
                icon="subscriber"
                connector="solid-arrow"
                onEvent={onEvent}
            >
                <p>
                    This article is available to subscribers who have digital
                    access included in their subscription.
                </p>
            </MessageBanner>

            <BlackFridayBreachContent
                breachDeal={breachDeal}
                breachCreativeName={breachCreativeName}
                breachType={breachType}
                onEvent={onEvent}
                title="50% off subscriptions"
                message={
                    <p>
                        Black Friday Sale on now.
                        <br /> Ends midnight, Monday.
                    </p>
                }
                cta="View Packages"
                subscriptionPackages={breachPackages['black-friday']}
            />
            <StyledWestRewardsMessage />
        </div>
    )
}
